import { AppWhiteLogoIcon } from "components/svg-icons";
import { Link, matchPath, useLocation } from "react-router-dom";
import AdminAccountMenu from "../admin-account-menu";

type MenuLink = {
  label: string;
  key: string;
};

function AdminNavbar(props: { menuLinks?: MenuLink[] }) {
  const { menuLinks = [] } = props;
  const { pathname } = useLocation();

  return (
    <div className="flex justify-between w-full bg-ciq-primary-200 text-white hover:text-white px-4">
      <div className="flex">
        <div className="flex items-center border-0 border-r border-solid py-2 pr-3 border-black">
          <Link
            to="/organizations"
            className="flex"
            data-testid="adminnavbar-link"
          >
            <div className="w-[120px] flex">
              <AppWhiteLogoIcon />
            </div>
          </Link>
        </div>
      </div>
      <div className="flex space-x-4 items-center h-full">
        <div className="flex h-full">
          {menuLinks.map((x) => (
            <Link
              key={x.key}
              to={x.key}
              className={
                matchPath(pathname, { path: x.key })
                  ? "ciq-nav-bar-menuActiveIconCSS hover:drop-shadow-[0_0_0.3px_rgba(0,0,0,1)]"
                  : "ciq-nav-bar-menuIconCSS hover:drop-shadow-[0_0_0.3px_rgba(0,0,0,1)]"
              }
              style={{ paddingRight: "10px", paddingTop: "10px" }}
              data-testid="adminnavbar-link-1"
            >
              {x.label}
            </Link>
          ))}
        </div>
        <div className="pl-3 py-2 flex justify-center items-center border-0 border-l border-solid border-black">
          <AdminAccountMenu />
        </div>
      </div>
    </div>
  );
}
export default AdminNavbar;
